export enum ConfigurationType {
	JSON = 'json',
	STRING = 'string',
	BOOLEAN = 'boolean',
	OBJECT = 'object',
}
